<template>
  <div class="comment-item">
    <img class="item-avatar" :src="item.avatar || 'http://image.xinli001.com/images/avatar.jpg!80'" alt="壹心理直播-评论">
    <div class="comment-item-right">
      <p class="item-name">
        {{  item.nickname }}
      </p>
      <div class="item-content">{{ item.content }}</div>
      <div class="operation-con">
        <p class="item.date">{{ item.createDate }}</p>
        <div>
            <span class="item-likeNum copyBtn" @click="likeClick">
              <span>{{ item.likeNumber | millionNum }}</span>
              <img v-if="item.alreadyLike" class="like-hover" src="../../assets/images/isLike.png" alt="壹心理直播">
              <svg-icon v-else icon-class="like"></svg-icon>
            </span>
          <span class="item-reply copyBtn" @click="conmentClick">
              <span>{{ item.replyNumber | millionNum }}</span>
              <svg-icon icon-class="comment"></svg-icon>
            </span>
        </div>
      </div>
      <div class="comment-child-con" v-for="childItem in item.childList" :key="childItem.id">
        <div class="comment-child">
          <div class="child-avatar">
            <img class="item-avatar" :src="childItem.avatar || 'http://image.xinli001.com/images/avatar.jpg!80'" alt="壹心理直播-评论">
            <p class="item-name">
              {{  childItem.nickname }}
              <span>回复</span>
              {{  childItem.toUserNickname }}
            </p>
          </div>
          <div class="item-content">{{ childItem.content }}</div>
          <div class="operation-con">
            <p class="item.date">{{ childItem.createDate }}</p>
            <div>
            <span class="item-likeNum copyBtn" @click="likeClick">
              <span>{{ childItem.likeNumber | millionNum }}</span>
              <img v-if="childItem.alreadyLike" class="like-hover" src="../../assets/images/isLike.png" alt="壹心理直播">
              <svg-icon v-else icon-class="like"></svg-icon>
            </span>
            <span class="item-reply copyBtn" @click="conmentClick">
              <span>{{ childItem.replyNumber | millionNum }}</span>
              <svg-icon icon-class="comment"></svg-icon>
            </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CommentItem",
    props: {
      item: {
        type: Object,
        default: () => {}
      },
      liveTitle: {
        type: String,
        default: ''
      }
    },
    methods: {
      likeClick() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            业务: '直播预告',
            行为: '点击',
            对象: '评论点赞',
            页面: '预告详情页',
            页面title: this.liveTitle
          }
        })
        // this.$emit('handleDownLoad')
      },
      conmentClick() {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            业务: '直播预告',
            行为: '点击',
            对象: '回复',
            页面: '预告详情页',
            页面title: this.liveTitle
          }
        })
        // this.$emit('handleDownLoad')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins";

  .comment-item {
    display: flex;
    justify-content: flex-start;
    margin: 24px 0;

    .comment-item-right {
      margin-left: 20px;
      padding-bottom: 30px;
      width: 100%;
      border-bottom: 1px solid #EAEAEA;

      .comment-child-con {
        padding: 20px 0;
      }

      .comment-child-con:last-child {
        padding-bottom: 0;
      }
    }

    .comment-child {
      margin: 0;

      .child-avatar {
        display: flex;
        align-items: center;
      }

      .item-name {
        margin-left: 20px;

        span {
          color: #21252D;
        }
      }
    }
  }

  .commen-child {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .item-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }

  .item-name {
    font-size: 26px;
    color: #6C798C;
    line-height: 48px;
    height: 48px;

    @include overLine(1);

    span {
      padding: 0 10px;
    }
  }

  .item-content {
    margin: 25px 0;
    font-size: 28px;
    color: #21252D;
    text-align: justify;
  }

  .operation-con {
      display: flex;
      justify-content: space-between;

      font-size: 22px;
      color: #BCC2CF;

      .item-likeNum,
      .item-reply {
        margin: 0 10px 0 10px;

        span {
          margin: 0 10px;
          color: #6C798C;
        }

        .like-hover {
          display: inline;
          width: 30px;
          margin-bottom: -5px;
        }

        .svg-icon {
          display: inline;
          width: 30px;
          height: 25px;
          vertical-align: -5px;
          color: #6C798C;
        }
      }
    }
</style>